import {IGNORE_Y_DIFF_IN_PX} from './constans'
import type {Rect} from '@wix/document-services-types'

const calculateYDifference = (y1: number, y2: number): number => {
    return Math.abs(y1 - y2) < IGNORE_Y_DIFF_IN_PX ? 0 : y1 - y2
}

export const compareByZRules = (rectA: Rect, rectB: Rect) => {
    return calculateYDifference(rectA!.y, rectB!.y) || rectA!.x - rectB!.x
}

export const compareBySRules = (rectA: Rect, rectB: Rect) => {
    return calculateYDifference(rectA!.y, rectB!.y) || rectB!.x - rectA!.x
}

export const compareBySOrZRules = (isRtl: boolean, rectA: Rect, rectB: Rect) => {
    return isRtl ? compareBySRules(rectA, rectB) : compareByZRules(rectA, rectB)
}
export const generatePinnedChildLayout = () => ({
    itemLayout: {
        type: 'GridItemLayout',
        alignSelf: 'start',
        justifySelf: 'start',
        gridArea: {
            rowStart: -1,
            rowEnd: 1,
            columnStart: -1,
            columnEnd: 1
        },
        pinnedToContainer: true
    }
})

export const generateChildLayout = (startRow: number) => ({
    itemLayout: {
        type: 'GridItemLayout',
        alignSelf: 'start',
        justifySelf: 'start',
        gridArea: {
            rowStart: startRow,
            rowEnd: startRow + 1,
            columnStart: 1,
            columnEnd: 2
        }
    }
})

export const generateContainerLayout = (rows: number) => ({
    rows: Array(rows).fill({type: 'minContent'}),
    columns: [{type: 'fr', value: 1}],
    type: 'GridContainerLayout'
})
